const motionConf = {
    transition: {
        duration: 1,
        ease: 'easeOut',
    },
    fastTransition : {
        duration: .25,
        ease: 'easeOut',
    },
    projectArchive: {
        from: { x: "100vw", overflowY:'hidden' },
        to: { x: 0, overflowY:'auto' },
    },
    projectSingle: {
        hidden: { x: 'calc(100vw -6rem)' },
        visible: { x: 0 }
    },
}
export default motionConf
